import Vue from 'vue'
import { i18n } from '../../utils/i18n.js'
import Button from '../button.vue'
import Modal from './modal.vue'

const prefixCls = 's-modal-confirm'

const message = {
  uk: {
    ok: 'OK',
    yes: 'Так',
    no: 'Ні',
    cancel: 'Відминити'
  },
  ru: {
    ok: 'OK',
    yes: 'Да',
    no: 'Нет',
    cancel: 'Отменить'
  },
  en: {
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel'
  },
}

Modal.newInstance = (properties) => {
  const instanceProps = properties || {}

  const Instance = new Vue({
    data: function() {
      return {
        ...instanceProps,
        visible: false,
        width: 736,
        title: '',
        body: '',
        //iconType: '',
        alerType: '',
        //iconName: '',
        okText: undefined,
        cancelText: undefined,
        showCancel: false,
        loading: false,
        buttonLoading: false,
        scrollable: false,
        closable: false,
        closing: false,
        dataQa: '',
      }
    },
    methods: {
      cancel() {
        if (this.closing) { return }
        this.$children[0].visible = false
        this.buttonLoading = false
        this.onCancel()
        this.remove()
      },
      ok() {
        if (this.closing) { return }
        if (this.loading) {
          this.buttonLoading = true
        } else {
          this.$children[0].visible = false
          this.remove()
        }
        this.onOk()
      },
      remove() {
        this.closing = true
        setTimeout(() => {
          this.closing = false
          this.destroy()
        }, 300)
      },
      destroy() {
        this.$destroy()
        if (this.$el) { document.body.removeChild(this.$el) }
        this.onRemove()
      },
      onOk() {},
      onCancel() {},
      onRemove() {},
    },
    computed: {
      alertClasses() {
        return { body: '' }
      },
      localeOkText() {
        if (this.okText) {
          return this.okText
        }
        return i18n(message).t('yes')
      },
      localeCancelText() {
        if (this.cancelText) {
          return this.cancelText
        }
        return i18n(message).t('no')
      },
    },
    render(h) {
      const footerVNodes = []
      footerVNodes.push(
        h(
          Button,
          {
            props: {
              loading: this.buttonLoading,
            },
            on: {
              click: this.ok,
            },
            attrs: {
              'data-qa': 'btn-ok',
            },
          },
          this.localeOkText
        )
      )
      if (this.showCancel) {
        footerVNodes.push(
          h(
            Button,
            {
              props: {
                type: 'text',
              },
              attrs: {
                'style': 'margin-left: 20px; --btn-color: var(--text-color);',
                'data-qa': 'btn-cancel',
              },
              on: {
                click: this.cancel,
              },
            },
            this.localeCancelText
          )
        )
      }

      const contentTextRender = []
      if (this.body) {
        contentTextRender.push(
          h('div', {
            attrs: {
              'class': `${prefixCls}-desc`,
              'data-qa': 'modal-body',
            },
            domProps: {
              innerHTML: this.body,
            },
          })
        )
      }

      return h(
        Modal,
        {
          props: { ...instanceProps,
            width: this.width,
            scrollable: this.scrollable,
            closable: this.closable,
            title: this.title,
            confirm: true
          },
          domProps: {
            value: this.visible,
          },
          on: {
            'input': (status) => {
              this.visible = status
            },
            'on-cancel': this.cancel,
          },
        },
        [
          h(
            'div',
            {
              attrs: {
                class: prefixCls,
              },
            },
            [
              contentTextRender,
              h(
                'div',
                {
                  attrs: {
                    class: `${prefixCls}-footer`,
                  },
                },
                footerVNodes
              ),
            ]
          ),
        ]
      )
    },
  })

  const component = Instance.$mount()
  document.body.appendChild(component.$el)
  const modal = Instance.$children[0]

  return {
    show(props) {
      modal.$parent.showCancel = props.showCancel
      modal.$parent.alerType = props.alerType

      if ('width' in props) {
        modal.$parent.width = props.width
      }

      if ('closable' in props) {
        modal.$parent.closable = props.closable
      }

      if ('title' in props) {
        modal.$parent.title = props.title
      }

      if ('content' in props) {
        modal.$parent.body = props.content
      }

      if ('okText' in props) {
        modal.$parent.okText = props.okText
      }

      if ('cancelText' in props) {
        modal.$parent.cancelText = props.cancelText
      }

      if ('width' in props) {
        modal.$parent.width = props.width
      }

      if ('onCancel' in props) {
        modal.$parent.onCancel = props.onCancel
      }

      if ('onOk' in props) {
        modal.$parent.onOk = props.onOk
      }

      if ('loading' in props) {
        modal.$parent.loading = props.loading
      }

      if ('scrollable' in props) {
        modal.$parent.scrollable = props.scrollable
      }

      if ('dataQa' in props) {
        modal.$parent.dataQa = props.dataQa
      }

      modal.$parent.onRemove = props.onRemove

      modal.visible = true
    },
    remove() {
      modal.visible = false
      modal.$parent.buttonLoading = false
      modal.$parent.remove()
    },
    component: modal,
  }
}

export default Modal
